<template>
  <div class="dangJianShe">
<!--    <div class="btn-list">-->
<!--      <div class="btn" @click="dialogVisible = true">添加人员</div>-->
<!--    </div>-->
    <div class="list ">
      <el-table
        :data="tableData"
        :header-cell-style="centerbgc"
        :cell-style="textCenter"
        style="width: 100%">
        <el-table-column
          label="培训人员名称"
          prop="name"
          width="250">
        </el-table-column>
<!--        <el-table-column-->
<!--          label="人员类型"-->
<!--          prop=""-->
<!--          width="160">-->
<!--        </el-table-column>-->
        <el-table-column
          width="300"
          prop="idcard"
          label="证件号码">
        </el-table-column>
        <el-table-column
          label="联系电话"
          prop="phone"
          width="280">
        </el-table-column>
        <el-table-column
          label="是否具有无犯罪证明"
          width="250">
          <template slot-scope="scope">
            <div class="desc">{{scope.row.have_zhengming == 1 ? '是' : '否'}}</div>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          label="聘用方式"-->
<!--          prop="pin_type"-->
<!--         >-->
<!--        </el-table-column>-->
        <el-table-column
          label="是否签订劳动合同"
          width="250">
          <template slot-scope="scope">
            <div class="desc">{{scope.row.have_hetong == 1 ? '是' : '否'}}</div>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          width="200"-->
<!--          label="教师资质">-->
<!--          <template slot-scope="">-->
<!--            <div class="desc color">&#45;&#45;&#45;&#45;</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
          label="操作"
          width="">
          <template slot-scope="scope" class="flex">
            <div class="edit pointer" @click="edit(scope)">查看</div>
<!--            <div class="del pointer" @click="del(scope)">删除</div>-->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page-box">
      <el-pagination
        :current-page.sync="search.page"
        :page-size="search.limit"
        :total="search.total"
        background
        class="page-all margin-top self-end"
        layout="prev, pager, next"
        @current-change="list">
      </el-pagination>
    </div>

    <peopleDialog :dialogVisible="dialogVisible" :id="peopleId" @handleClose="handleClose" />
  </div>
</template>
<script>
import peopleDialog from "@/views/admin/pages/orgDetail/orgOperation/dialog/peopleDialog";
import {del_employ, employ_lst} from "@/api/admin";
export default {
  name: "renyuan",
  data() {
    return {
      org_id:'',
      dialogVisible:false,
      peopleId:'',
      tableData:[1],
      search:{
        page:1,
        limit:10,
        total:0,
      }
    }
  },
  components: {peopleDialog},
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.org_id = this.$route.query.org_id
    this.list()
  },
  methods: {

    // 获取列表
    async list() {
      let _data = await employ_lst (
        this.org_id,
        this.search.page,this.search.limit
      );
      if (_data.status === 200) {
        this.tableData = _data.data.data
        this.total = _data.data.total
      } else {
        this.$message.error(_data.msg)
      }
    },
    edit(scope){
      this.dialogVisible = true
      this.peopleId = scope.row.id
    },
    del(scope) {
      this.$confirm('此操作将删除该数据，是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.expertDel(scope.row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    async expertDel(id) {
      let _data = await del_employ(this.org_id,id)
      if (_data.status === 200) {
        this.$message.success(_data.msg)
        this.list()
      } else {
        this.$message.error(_data.msg)
      }
    },

    handleClose(){
      this.dialogVisible = false
      this.peopleId = ''
      // this.list()
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.dangJianShe {
  .edit {
    font-size: 14px;
    color: #0089ff;
    padding: 4px 10px;
    display: inline-block;
  }
  .del {
    font-size: 14px;
    color: #ff0000;
    padding: 4px 10px;
    display: inline-block;
  }
  .btn-list {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-bottom: 20px;


    .btn {
      width: 180px;
      height: 40px;
      background-image: linear-gradient(0deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 5px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      letter-spacing: 1px;
      color: #ffffff;
      cursor: pointer;
      margin-left: 30px;
    }
  }


}
</style>


